import { Controller } from "@hotwired/stimulus"

// Prefills the match-values (labels) input with the picked customer's number
// (Cup::Combobox stamps it on the hidden field when a customer is picked),
// but only while the field is still empty so a hand-typed label is never
// overwritten.
export default class extends Controller {
  static targets = ["select", "values"]

  fill() {
    const number = this.selectTarget.dataset.customerNumber
    if (number && this.valuesTarget.value.trim() === "") {
      this.valuesTarget.value = number
    }
  }
}
